/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 本体商品
 */
export interface Szoa109aResponsePrdSearchResultDtoHontiGoodsPrm { 
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * プロダクト商品正式名称：全角
     */
    prdGoodsAname?: string;
    /**
     * プロダクト商品略称名称：全角
     */
    prdGoodsRyaku?: string;
    /**
     * プロダクト商品画面用名称：全角
     */
    prdGoodsDisp?: string;
    /**
     * 契約満了期間区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008240」のユーザコードを設定
     */
    ctrExpireDiv?: string;
    /**
     * 契約満了期間区分名称：全半角混在
     */
    ctrExpireDivAname?: string;
    /**
     * 契約満了期間
     */
    ctrExpirePeriod?: number;
    /**
     * 商品構成順番：数字
     */
    goodsCompoTurn?: string;
    /**
     * 商品正式名称：全角
     */
    goodsAname?: string;
    /**
     * 商品略称名称：全角
     */
    goodsRyaku?: string;
    /**
     * 商品画面表示用名：全角
     */
    goodsDispAname?: string;
    /**
     * 約款別パターン：英数字<br>　コード変換マスターテーブル.画面項目ID「D400040」のユーザコードを設定
     */
    stiPtn?: string;
    /**
     * 約款別パターン名称：全半角混在
     */
    stiPtnAname?: string;
}

